import { Avatar, Badge, Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

function ThreadHeader({ participants, commentCount, status, onClose }) {
  const { t } = useTranslation('work-queues-app');
  const isOpen = status === 'open';

  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
        <p className="shrink-0 text-sm font-semibold text-content">{t('thread.comments')}</p>
        <span className="text-xs text-content-faint">{t('thread.qa')}</span>
        {participants.length > 0 ? (
          <>
            <div className="flex shrink-0 items-center -space-x-1">
              {participants.map((participant) => (
                <Avatar
                  key={participant.author}
                  size="sm"
                  initials={participant.initials}
                  alt={participant.author}
                  className="border-surface bg-neutral-800 text-[8px] text-white dark:bg-neutral-700"
                />
              ))}
            </div>
            <span className="truncate text-xs text-content-faint">
              {t('thread.count', { count: commentCount })}
            </span>
          </>
        ) : null}
      </div>
      <div className="flex shrink-0 items-center gap-1">
        <Badge variant={isOpen ? 'success' : 'neutral'} size="small">
          {t(`thread.status.${status}`, { defaultValue: status }).toUpperCase()}
        </Badge>
        {isOpen ? (
          <Button
            variant="ghost"
            size="sm"
            className="!px-1 text-[#2173FF] dark:text-blue-400"
            onClick={onClose}
          >
            {t('thread.close')}
          </Button>
        ) : null}
      </div>
    </div>
  );
}

export default ThreadHeader;
